import {createTheme} from '@mui/material/styles'
import {heIL} from '@mui/material/locale'
import createCache from '@emotion/cache'
import {prefixer} from 'stylis'
import rtlPlugin from 'stylis-plugin-rtl'
import fonts from 'appearance/fonts'
import {colorVariableMap, lightColors, darkColors} from 'appearance/colorTokens'

const cacheLtr = createCache({
    key: 'muiltr',
})

const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
})

const COLOR_MODE_STORAGE_KEY = 'app-color-mode'

const getColorTokens = (mode) => (mode === 'dark' ? darkColors : lightColors)

const getPaletteTokens = (mode) => {
    const tokens = getColorTokens(mode)
    return {
        mode,
        primary: {
            main: tokens.primary,
        },
        secondary: {
            main: tokens.secondary,
        },
        success: {
            main: tokens.success,
        },
        error: {
            main: tokens.danger,
        },
        warning: {
            main: tokens.warning,
        },
        info: {
            main: tokens.info,
        },
        background: {
            default: tokens.background,
            paper: mode === 'dark' ? '#1f2937' : '#ffffff',
        },
        text: {
            primary: mode === 'dark' ? '#f3f4f6' : '#111827',
            secondary: mode === 'dark' ? '#9ca3af' : '#6b7280',
        },
        divider: mode === 'dark' ? '#374151' : '#e5e7eb',
    }
}

const extractFontFamily = (fontValue) => fontValue.replace(/['"]/g, '')

const createAppTheme = ({mode = 'light', direction = 'ltr'} = {}) => {
    const themeOptions = {
        direction,
        palette: getPaletteTokens(mode),
        shape: {
            borderRadius: 8,
        },
        typography: {
            fontFamily: extractFontFamily(fonts.APP_MAIN),
            h6: {
                fontWeight: 600,
            },
            subtitle1: {
                fontWeight: 500,
            },
            button: {
                textTransform: 'none',
                fontWeight: 600,
            },
        },
        components: {
            MuiPaper: {
                styleOverrides: {
                    root: {
                        // borderRadius: 16,
                    },
                },
            },
            MuiSwitch: {
                styleOverrides: {
                    root: {padding: 8},
                    // switchBase: {
                    //     '&.Mui-checked': {
                    //         color: palette.primary.main,
                    //     },
                    //     '&.Mui-checked + .MuiSwitch-track': {
                    //         backgroundColor: palette.primary.main,
                    //     },
                    // },
                    track: {
                        borderRadius: 16,
                    },
                },
            },
        },
    }

    return direction === 'rtl' ? createTheme(themeOptions, heIL) : createTheme(themeOptions)
}

const applyCssVariables = (mode = 'light') => {
    if (typeof document === 'undefined') return

    const tokens = getColorTokens(mode)

    Object.entries(colorVariableMap).forEach(([key, cssVar]) => {
        const value = tokens[key] ?? lightColors[key]
        document.documentElement.style.setProperty(cssVar, value)
    })

    document.body.style.backgroundColor = tokens.background
    document.body.style.color = mode === 'dark' ? tokens.white : tokens.dark
    document.documentElement.setAttribute('data-theme', mode)
}

export {cacheLtr, cacheRtl, createAppTheme, applyCssVariables, COLOR_MODE_STORAGE_KEY}

if (typeof window !== 'undefined') {
    const storedMode = localStorage.getItem(COLOR_MODE_STORAGE_KEY) || 'light'
    applyCssVariables(storedMode)
}
